import actions from './actions';

const initialState = {
  isSearching: false,
  isCreating: false,
  isUpdating: false,
  isDeleting: false,
};

export default function relayReducer(state = initialState, action) {
  switch (action.type) {
    case actions.CREATE_EXTERNAL_CODE_GENERATOR:
      return {
        ...state,
        isCreating: true,
      };
    case actions.CREATE_EXTERNAL_CODE_GENERATOR_ENDED:
      return {
        ...state,
        isCreating: false,
      };
    case actions.SEARCH_EXTERNAL_CODE_GENERATORS:
      return {
        ...state,
        isSearching: true,
      };
    case actions.SEARCH_EXTERNAL_CODE_GENERATORS_ENDED:
      return {
        ...state,
        isSearching: false,
      };
    case actions.UPDATE_EXTERNAL_CODE_GENERATOR:
      return {
        ...state,
        isUpdating: true,
      };
    case actions.UPDATE_EXTERNAL_CODE_GENERATOR_ENDED:
      return {
        ...state,
        isUpdating: false,
      };
    case actions.DELETE_EXTERNAL_CODE_GENERATOR:
      return {
        ...state,
        isDeleting: true,
      };
    case actions.DELETE_EXTERNAL_CODE_GENERATOR_ENDED:
      return {
        ...state,
        isDeleting: false,
      };
    default:
      return state;
  }
}
